
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "QuoteComponent",
  components: { FontAwesomeIcon },
  props: {
    quote:{
			type: String,
			required:true,
    },
		author:{
			type: String,
			required:true,
		}
  },
});
